import { AuthorBody, ReviewerBody } from '@react/shared/types/usePrefetch';

export function authorPageFunc(author: AuthorBody) {
  const authorLd: Record<string, unknown> = {};
  authorLd['@type'] = 'Person';
  authorLd.name = author.fullName;
  if (author.award && author.award.length > 0) {
    authorLd.award = author.award.map((award) => award.Award);
  }
  if (author.linkedIn) {
    authorLd.sameAs = author.linkedIn;
  }
  authorLd.worksFor = {
    '@type': 'Organization',
    name: author?.worksFor || 'Seniorly',
  };
  if (author.jobTitle) {
    authorLd.jobTitle = {
      '@type': 'DefinedTerm',
      name: author.jobTitle,
    };
  }
  if (author.alumniOf && author.alumniOf.length > 0) {
    authorLd.alumniOf = author.alumniOf.map((alumni) => ({
      '@type': 'CollegeOrUniversity',
      name: alumni.alumniOf,
    }));
  }
  if (author.hasCredential && author.hasCredential.length > 0) {
    authorLd.hasCredential = author.hasCredential.map((credential) => ({
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: credential.type || 'degree',
      educationalLevel: credential.isMasters ? 'advanced' : undefined,
      name: credential.name,
    }));
  }
  if (author.knowsAbout && author.knowsAbout.length > 0) {
    authorLd.knowsAbout = author.knowsAbout.map((knows) => {
      return {
        '@type': 'Thing',
        name: knows.name,
      };
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'ProfilePage',
    dateModified: author.updatedAt,
    dateCreated: author.createdAt,
    mainEntity: authorLd,
  };
}

export function reviewerPageFunc(
  reviewerLd: Record<string, unknown>,
  reviewer: ReviewerBody
) {
  reviewerLd['@context'] = 'https://schema.org';
  reviewerLd['@type'] = 'Person';
  reviewerLd.name = reviewer.fullName;
  if (reviewer?.award?.length) {
    reviewerLd.award = reviewer.award.map((award) => award.Award);
  }
  if (reviewer.linkedIn) {
    reviewerLd.sameAs = reviewer.linkedIn;
  }
  reviewerLd.worksFor = {
    '@type': 'Organization',
    name: reviewer?.worksFor || 'Seniorly',
  };
  if (reviewer.jobTitle) {
    reviewerLd.jobTitle = {
      '@type': 'DefinedTerm',
      name: reviewer.jobTitle,
    };
  }
  if (reviewer?.alumniOf?.length) {
    reviewerLd.alumniOf = reviewer.alumniOf.map((alumni) => ({
      '@type': 'CollegeOrUniversity',
      name: alumni.alumniOf,
    }));
  }
  if (reviewer?.hasCredential?.length) {
    reviewerLd.hasCredential = reviewer.hasCredential.map((credential) => ({
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: credential.type || 'degree',
      educationalLevel: credential.isMasters ? 'advanced' : undefined,
      name: credential.name,
    }));
  }
  if (reviewer?.knowsAbout?.length) {
    reviewerLd.knowsAbout = reviewer.knowsAbout.map((knows) => ({
      '@type': 'Thing',
      name: knows.name,
    }));
  }
  return reviewerLd;
}
